import { render, staticRenderFns } from "./ModalInteiroTeor.vue?vue&type=template&id=ce54b9b8&"
import script from "./ModalInteiroTeor.vue?vue&type=script&lang=js&"
export * from "./ModalInteiroTeor.vue?vue&type=script&lang=js&"
import style0 from "./ModalInteiroTeor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports